import DepositoForm from './DepositoForm.vue'
export default DepositoForm

